Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SensorType = exports.ReduceMotion = exports.KeyboardState = exports.InterfaceOrientation = exports.IOSReferenceFrame = void 0;
var SensorType = exports.SensorType = function(SensorType) {
    SensorType[SensorType["ACCELEROMETER"] = 1] = "ACCELEROMETER";
    SensorType[SensorType["GYROSCOPE"] = 2] = "GYROSCOPE";
    SensorType[SensorType["GRAVITY"] = 3] = "GRAVITY";
    SensorType[SensorType["MAGNETIC_FIELD"] = 4] = "MAGNETIC_FIELD";
    SensorType[SensorType["ROTATION"] = 5] = "ROTATION";
    return SensorType;
}({});
var IOSReferenceFrame = exports.IOSReferenceFrame = function(IOSReferenceFrame) {
    IOSReferenceFrame[IOSReferenceFrame["XArbitraryZVertical"] = 0] = "XArbitraryZVertical";
    IOSReferenceFrame[IOSReferenceFrame["XArbitraryCorrectedZVertical"] = 1] = "XArbitraryCorrectedZVertical";
    IOSReferenceFrame[IOSReferenceFrame["XMagneticNorthZVertical"] = 2] = "XMagneticNorthZVertical";
    IOSReferenceFrame[IOSReferenceFrame["XTrueNorthZVertical"] = 3] = "XTrueNorthZVertical";
    IOSReferenceFrame[IOSReferenceFrame["Auto"] = 4] = "Auto";
    return IOSReferenceFrame;
}({});
var InterfaceOrientation = exports.InterfaceOrientation = function(InterfaceOrientation) {
    InterfaceOrientation[InterfaceOrientation["ROTATION_0"] = 0] = "ROTATION_0";
    InterfaceOrientation[InterfaceOrientation["ROTATION_90"] = 90] = "ROTATION_90";
    InterfaceOrientation[InterfaceOrientation["ROTATION_180"] = 180] = "ROTATION_180";
    InterfaceOrientation[InterfaceOrientation["ROTATION_270"] = 270] = "ROTATION_270";
    return InterfaceOrientation;
}({});
var KeyboardState = exports.KeyboardState = function(KeyboardState) {
    KeyboardState[KeyboardState["UNKNOWN"] = 0] = "UNKNOWN";
    KeyboardState[KeyboardState["OPENING"] = 1] = "OPENING";
    KeyboardState[KeyboardState["OPEN"] = 2] = "OPEN";
    KeyboardState[KeyboardState["CLOSING"] = 3] = "CLOSING";
    KeyboardState[KeyboardState["CLOSED"] = 4] = "CLOSED";
    return KeyboardState;
}({});
var ReduceMotion = exports.ReduceMotion = function(ReduceMotion) {
    ReduceMotion["System"] = "system";
    ReduceMotion["Always"] = "always";
    ReduceMotion["Never"] = "never";
    return ReduceMotion;
}({});
